import styled from 'styled-components';
import FormLabel from '../atoms/FormLabel';
import Input from '../atoms/Input';
import space from '../utils/style/space';
import color from '../utils/style/color';
import InputContainer from '../atoms/InputContainer';

type Props = {
  label: string;
  type: string;
  value: string;
  disabled: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  autoComplete?: string;
  errorMessage?: string;
};

const ErrorMessage = styled.p`
  margin-top: ${space.xxxs}px;
  color: ${color.red.error};
`;

const InputForm = (props: Props) => {
  const errorMessage = props.errorMessage ? (
    <ErrorMessage>{props.errorMessage}</ErrorMessage>
  ) : null;

  return (
    <InputContainer>
      <FormLabel>{props.label}</FormLabel>
      <Input
        placeholder={props.placeholder}
        type={props.type}
        value={props.value}
        disabled={props.disabled}
        onChange={props.onChange}
        autoComplete={props.autoComplete ? props.autoComplete : props.type}
      />
      {errorMessage}
    </InputContainer>
  );
};

InputForm.defaultProps = {
  disabled: false
};

export default InputForm;
